import { render } from "./AttributeCreate.vue?vue&type=template&id=16b5abd2"
import script from "./AttributeCreate.vue?vue&type=script&lang=js"
export * from "./AttributeCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__